export const PXAccordionFaq = (function() {
	'use strict';

	function openAccordionById(anchorId) {
		// Close all open accordion items first
		const allAccordionItems = document.querySelectorAll('[data-accordion-item].is-open');
		allAccordionItems.forEach(item => {
			item.classList.remove('is-open');
			const trigger = item.querySelector('.accordion-trigger');
			const content = item.querySelector('.accordion-content');
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
			if (content) content.setAttribute('hidden', '');
		});

		const accordionItem = document.getElementById(anchorId);
		if (accordionItem && accordionItem.hasAttribute('data-accordion-item')) {
			const trigger = accordionItem.querySelector('.accordion-trigger');
			const content = accordionItem.querySelector('.accordion-content');
			if (!accordionItem.classList.contains('is-open')) {
				accordionItem.classList.add('is-open');
				if (trigger) trigger.setAttribute('aria-expanded', 'true');
				if (content) content.removeAttribute('hidden');
			}
			accordionItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	function handleHashAccordion() {
		const hash = window.location.hash.replace('#', '');
		if (hash) {
			openAccordionById(hash);
		}
	}

	function init() {
		events();
		handleHashAccordion();
		window.addEventListener('hashchange', handleHashAccordion);
	}

	function events() {
		const triggers = document.querySelectorAll('[data-accordion-item] .accordion-trigger');

		triggers.forEach(trigger => {
			trigger.addEventListener('click', handleAccordionClick);
		});
	}

	function handleAccordionClick(e) {
		const trigger = e.currentTarget;
		const accordionItem = trigger.closest('[data-accordion-item]');
		const content = accordionItem.querySelector('.accordion-content');
		const isOpen = accordionItem.classList.contains('is-open');

		if (isOpen) {
			// Close this accordion
			accordionItem.classList.remove('is-open');
			trigger.setAttribute('aria-expanded', 'false');
			content.setAttribute('hidden', '');
		} else {
			// Open this accordion
			accordionItem.classList.add('is-open');
			trigger.setAttribute('aria-expanded', 'true');
			content.removeAttribute('hidden');
		}
	}

	return {
		init: init
	};
})();
